/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 6V13.5H6V6H18ZM18 4H6C5.46956 4 4.96086 4.21072 4.58579 4.58579C4.21071 4.96087 4 5.46957 4 6V15.5H20V6C20 5.46957 19.7893 4.96087 19.4142 4.58579C19.0391 4.21072 18.5304 4 18 4Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 16.5H22V17.095C22 17.6002 21.7993 18.0848 21.442 18.442C21.0848 18.7993 20.6002 19 20.095 19H3.905C3.39976 19 2.91522 18.7993 2.55796 18.442C2.2007 18.0848 2 17.6002 2 17.095V16.5Z",
  fill: "currentColor"
})), 'CategoryIN');